(function($){

	var ajaxAddToCart = function(){
		var atcButton = $('.ms-ajax-add-to-cart');

		var productInfo = {
			id: null,
			type: null,
			slug: null, 
			sku: null,
			quantity: 1,
			variations: null,
			groupedProducts: null,
			productBundles: null,
		};

		var refreshHeaderCartCount = function(){
			$('.header-cart-items').hide();
			$('[data-action="msw-header-cart-count"]').empty();
			$.ajax({
				url: MSWObject.ajax_url,
				method: 'POST',
				data: {
					action: 'ms_ajax_header_cart',
					woo_ajax_object: productInfo,
				},
				fail: function(textStatus) { console.log(textStatus); },
				success: function( response ) {
					$('[data-action="msw-header-cart-count"]').prepend( response ); 
					$('.header-cart-items').show();
				},				
			});
		}

		var addToCart = function(productInfo) {
			var query = $.ajax({
				url: MSWObject.ajax_url,
				method: 'POST',
				data: {
					action: 'ms_ajax_atc',
					woo_ajax_object: productInfo,
				},
				fail: function(textStatus) { console.log(textStatus); },
				success: function() { 
					$('body').removeClass('pending');
					$('.add-to-cart-container').addClass('active');
					refreshHeaderCartCount();
				},
			});
		};

		atcButton.on('click', function(e) {
			e.preventDefault();
			$('body').addClass('pending');

			productInfo.variations = null;
			productInfo.groupedProducts = null;
			productInfo.productBundles = null;

			var target = $(e.currentTarget);
			var productOptions = [];

			productInfo.type = target.attr('data-product_type');
			productInfo.id = target.attr('data-product_id');
			productInfo.slug = target.attr('data-product_slug');
			productInfo.sku = target.attr('data-product_sku');
			productOptionSelector = $('.' + productInfo.id + '-' + productInfo.type + '-' + productInfo.slug);
			productInputSelector = $('.' + productInfo.id + '-' + productInfo.type + '-' + productInfo.slug + '-quantity');
			productInfo.quantity = productInfo.quantity = productInputSelector.val();
			if(productInfo.quantity == '') { 
				productInfo.quantity = 1;
			}

			switch(productInfo.type) {
				case 'simple':
					break;
				case 'variable':
					$.each(productOptionSelector, function() {
						var name = $(this).attr('data-variable_name');
						var selected = this.options[this.selectedIndex].text;
						var variation = {
							name: name,
							selected: selected,
						};
						productOptions.push(variation);
					});
					productInfo.variations = productOptions;
					break;
				case 'grouped':
					$.each(productOptionSelector, function() {
						var id = $(this).attr('data-product_id');
						var quantity = $(this).find('input').val();
						var childProduct = {
							id: id,
							quantity: quantity
						};
						productOptions.push(childProduct);
					});
					productInfo.groupedProducts = productOptions;
					break;
				default:
					break;
			}
			addToCart(productInfo);
		});
	};

	var updateLineItem = function() {
		$('.cart-item__edit').on('click', function(e) {
			var lineItem = $(e.currentTarget).closest('.cart-item');
			var quantity = lineItem.find('.cart-item__quantity-edit').val();
			var key = lineItem.data('cart-item-key');
			$(e.currentTarget).closest('.cart-item__controls').addClass('edit');
			var query = $.ajax({
				url: MSWObject.ajax_url,
				method: 'POST',
				data: {
					action: 'update_line_item',
					key: key,
					quantity: quantity,
				},
				fail: function(textStatus) { console.log(textStatus); },
				success: function() { 
					$(e.currentTarget).closest('.cart-item__controls').removeClass('edit');
					$(e.currentTarget).closest('.cart-item__controls').addClass('done');
					setTimeout(function() {
						$(e.currentTarget).closest('.cart-item__controls').removeClass('done');
						if(parseInt(quantity) == 0) {
							window.location.href = window.location.href;
						}
					}, 1000);
				},
			});
		})
	}

	var submitOrder = function() {
		var submitButton = $('.page-template-page_quote .gform_button');
		var product = $('.page-template-page_quote .cart-item');
		submitButton.on('click', function(e) {
			e.preventDefault();
			$('body').addClass('pending');
			var firstName = $('.quote-first-name .ginput_container input').val();
			var lastName = $('.quote-last-name .ginput_container input').val();
			var email = $('.quote-email .ginput_container input').val();
			var phone = $('.quote-phone .ginput_container input').val();
			var message = $('.quote-message .ginput_container textarea').val();
			var customer = {
				first_name: firstName,
				last_name: lastName,
				email: email,
				phone: phone,
				message: message,
			};

			var order = [];
			$.each(product, function() {
				order.push({
					id: $(this).data('product-id'),
					quantity: parseInt($(this).data('quantity')),
				});
			});
			var query = $.ajax({
				url: MSWObject.ajax_url,
				method: 'POST',
				data: {
					action: 'create_order',
					customer: customer,
					order: order
				},
				fail: function(textStatus) { console.log(textStatus); },
				success: function(res) { 
					$('body').removeClass('pending');
					$('html, body').animate({ scrollTop: ($('.wysiwyg').offset().top - $('.site-header').innerHeight()) });
					if(res.has_errors == true) {
						var errors = '<p class="errors-heading">Your submission contained the following errors.</p>';
						errors += '<ul class="errors">';
						$.each(res.errors, function() {
							errors += '<li class="error">' + this.error_message + '</li>';
						})
						errors += '</ul>';
						$('.gform_body').prepend(errors);
					} else {
						$('body .errors').remove();
						$('body .errors-heading').remove();
						$('.wysiwyg').addClass('success');
					}					
				},
			});
		});
	};

	$(document).ready(function(){
		ajaxAddToCart();
		updateLineItem();
		submitOrder();
	});

})(jQuery);